import React, { useState, useEffect } from 'react';

function PartEncodeImg(props) {

    const [OpenCV, setOpenCV] = useState(null);
    const [inEnSrc, setInEnSrc] = useState();
    const [outEnSrc, setOutEnSrc] = useState();
    const [enfilename, setEnFileName] = useState();
    // const [lable, setLable] = useState('暂未上传图片');

    useEffect(() => {
        setOpenCV(props.opencv)
    }, [props.opencv]);


    /**为加快dft，对要处理的图片尺寸进行优化 */
    function optimizeImageDim(mat) {
        // get optimal size of DFT
        let optimalRows = OpenCV.getOptimalDFTSize(mat.rows);
        let optimalCols = OpenCV.getOptimalDFTSize(mat.cols);
        let s0 = OpenCV.Scalar.all(0);
        let padded = new OpenCV.Mat();
        OpenCV.copyMakeBorder(mat, padded, 0, optimalRows - mat.rows, 0,
            optimalCols - mat.cols, OpenCV.BORDER_CONSTANT, s0);

        return padded
    }

    function dftOnePlane(plane) {

        plane.convertTo(plane, OpenCV.CV_32F);

        //为实部虚部构建 MatVector
        let planes = new OpenCV.MatVector();
        //添加进 planes
        planes.push_back(plane);
        planes.push_back(new OpenCV.Mat.zeros(plane.size(), OpenCV.CV_32F));

        //合并到 complexI
        let complexI = new OpenCV.Mat();
        OpenCV.merge(planes, complexI);

        //dft
        OpenCV.dft(complexI, complexI);

        return complexI;
    }

    function encodeImg(e) {
        // 加载
        let src = OpenCV.imread(e.target);
        // 尺寸优化
        let opsrc = optimizeImageDim(src);


        // 获得所有通道
        let allPlanes = new OpenCV.MatVector();
        OpenCV.split(opsrc, allPlanes);

        //获得一通道
        let plane0 = new OpenCV.Mat();
        plane0 = allPlanes.get(0);

        //对该通道进行dft
        let complexI = dftOnePlane(plane0);


        // //向上取整，保证有1 
        // let cols = Math.ceil(complexI.cols / 512)
        // let rows = Math.ceil(complexI.rows / 1024)
        // // 添加文本水印
        // let scalar = new OpenCV.Scalar(0, 0, 0);
        // for (let j = 0; j < rows; j++) {
        //     for (let i = 0; i < cols; i++) {
        //         // console.log('i-j', 50 + i * 512, 50 + j * 512)
        //         OpenCV.putText(complexI, 'huahua', new OpenCV.Point(50 + i * 512, 50 + j * 512),
        //             OpenCV.FONT_HERSHEY_DUPLEX, 2.0, scalar);
        //         OpenCV.flip(complexI, complexI, -1);
        //         OpenCV.putText(complexI, 'huahua', new OpenCV.Point(50 + i * 512, 50 + j * 512),
        //             OpenCV.FONT_HERSHEY_DUPLEX, 2.0, scalar);
        //         OpenCV.flip(complexI, complexI, -1);
        //     }
        // }

        let scalar = new OpenCV.Scalar(0, 0, 0);
        OpenCV.putText(complexI, 'huahua', new OpenCV.Point(50, 50),
            OpenCV.FONT_HERSHEY_DUPLEX, 2.0, scalar);
        OpenCV.flip(complexI, complexI, -1);
        OpenCV.putText(complexI, 'huahua', new OpenCV.Point(50, 50),
            OpenCV.FONT_HERSHEY_DUPLEX, 2.0, scalar);
        OpenCV.flip(complexI, complexI, -1);

        // idft
        OpenCV.dft(complexI, complexI, OpenCV.DFT_INVERSE | OpenCV.DFT_SCALE | OpenCV.DFT_REAL_OUTPUT, 0);

        complexI.convertTo(complexI, OpenCV.CV_8U);

        //替换掉原来的一通道
        allPlanes.set(0, complexI);

        let lastImage = new OpenCV.Mat();
        OpenCV.merge(allPlanes, lastImage);

        OpenCV.imshow('enCanvas', lastImage);

        setInEnSrc('')
        let canvas = document.getElementById('enCanvas');
        let href = canvas.toDataURL("image/png", 1);
        setOutEnSrc(href);
        canvas.width = 1;
        canvas.height = 1;
        // setLable('完成加密,点击下载')
    }

    return (
        <div className="col-md-12 p-2">
            <div className="h-100 p-5 pb-4 text-white bg-dark rounded-3">
                <h2>加密</h2>
                <p>使用傅里叶变换对图片G通道进行加密，逆变后再替换原通道</p>

                <input type="file"
                    style={{ width: 200, marginTop: 10 }}
                    onChange={(e) => {
                        setInEnSrc(URL.createObjectURL(e.target.files[0]))
                        let name = e.target.files[0].name;
                        setEnFileName(name.substring(0, name.indexOf(".")))
                        // setLable('上传成功,正在处理...')
                        // console.log('url', URL.createObjectURL(e.target.files[0]))
                    }} />


                {inEnSrc ?
                    <img
                        alt=' '
                        src={inEnSrc}
                        onLoad={(e) => {
                            if (OpenCV) {
                                console.log('---OpenCV---', OpenCV)
                                encodeImg(e);
                            }
                        }}
                    ></img> : ''
                }


                <canvas
                    id="enCanvas"
                    width={1}
                    height={1}
                ></canvas>

                {outEnSrc ?
                    <a className="btn btn-outline-light mt-4" type="button"
                        style={{
                            width: 100,
                            display: 'block'
                        }}
                        href={outEnSrc}
                        download={'encode-' + enfilename}
                    >
                        下载结果
                    </a>
                    :
                    ''
                }

            </div>
        </div>
    )
}

export default PartEncodeImg;